<!-- D-Pad Button Component -->
<script lang="ts">
	import { createEventDispatcher } from "svelte";

	export let orientation, defaultstyle, buttonStyle, mapping
	export let button: string;

	const dispatch = createEventDispatcher();
	function pressButton(uod: string) {
		dispatch('message', {
			event: button,
			value: uod
		})
	}
</script>

<!-- Note that {mapping} and {button} values can likely be merged to clean up code -->
<div class="recess {orientation} {defaultstyle ? 'shadow' : 'glass'} recess-{buttonStyle}" id="button_{ mapping }">

	<button value={button} class="button shadow button-{buttonStyle}"
		on:mousedown|preventDefault={() => pressButton('down')}
		on:touchstart|preventDefault={() => pressButton('down')}
		on:mouseup|preventDefault={() => pressButton('up')}
		on:touchend|preventDefault={() => pressButton('up')}
	>
		<div class="label dpad_{button}" />
	</button>

</div>


<style>
	/* Default button styles*/
	.button {
		transition: all 0.2s;
	}
	.button:active {
		background-color: #fff !important;
	}

	/* {buttonStlye} value toggles between "default" and "colour" */
	#button_L, #button_L .button {
		border-radius: 8px var(--r_size) var(--r_size) 8px;
	}
	#button_U, #button_U .button {
		border-radius: 8px 8px var(--r_size) var(--r_size);
	}
	#button_D, #button_D .button {
		border-radius: var(--r_size) var(--r_size) 8px 8px;
	}
	#button_R, #button_R .button {
		border-radius: var(--r_size) 8px  8px  var(--r_size);
	}

	/* Orientations */
	.T { top: 0;}
	.B { bottom: 0;}
	.L { left: 0;}
	.R { right: 0;}

	.TM { top: 10%; }
	.BM { bottom: 10%; }
	.LM { left: 10%; }
	.RM { right: 10%; }

	/* Label positioning */
	.label {
		/* font-size: 1.3rem; */
		/* font-weight: 700; */
		/* margin-top: 0%; */
		color: rgba(0,0,0,0.3);
		/* border: 1px solid red; */
	}

	/* Default theme */
	.recess-default {
		box-shadow: inset 0 10px 15px rgb(0 0 0 / 30%);
	}
	.button-default {
		background-color: rgba(0,0,0,0);
		border: 1.5px solid rgba(255,255,255,1);
	}
	.button-default div.label {
		color: rgba(255,255,255,0.75);
	}

	/* Xbox Theme */
	.recess-colour {
		/* background: linear-gradient(0deg, rgba(255,255,255,0.1) 30%, rgba(0,0,0,0.2) 70%); */
		background: rgba(0,0,0,0);
		box-shadow: none !important;
	}
	.button-colour {
		color: rgba(255, 255, 255, 0.25);
		background: linear-gradient(0deg, rgba(50,50,50,1) 0%, rgba(0,0,0,1) 90%, rgba(60,60,60,1) 100%);
		box-shadow: inset 0 -4px 0px rgb(0 0 0 / 30%);
	}
	.button-colour:active{
		box-shadow: inset 0 -1px 0px rgb(0 0 0 / 30%) !important;
	}
	.button-colour div.label {
		color: rgba(255, 255, 255, 0);
	}
	/* .button-colour:active div.label {
		transition: all 0.2s;
		margin-top: 10%;
	} */

	/* MTN Theme */
	.recess-mtn {
		background-color: rgba(0, 0, 0, 0);
		box-shadow: none !important;
	}
	.button-mtn {
		background-color: rgba(0, 0, 0, 0.75);
		box-shadow: none !important;
		border: 2px solid rgba(255, 255, 255, 0.15);
	}
	.button-mtn .label {
		color: #ffc107;
	}
</style>
